import Sidebar from './sidebar-container'

export default Sidebar
